import './index.scss';
import './hero.scss';
import './space.scss';

class SidebarMenu {
    constructor(root) {
        this.root = root;

        this.sidebar = document.querySelector('.doktype-post__col--sidebar');
        this.content = document.querySelector('.doktype-post__col--content');

        this.sidebarLinks = this.sidebar.querySelectorAll('a.sidebar-menu__link--internal');
        this.contentItems = {};

        this.sidebarLinks.forEach((link) => {
            const item = this.content.querySelector(link.hash);
            if (item) { this.contentItems[link.hash] = item; }
        });

        this.initToggle();
        this.scroll();

        window.addEventListener('resize', this.resize.bind(this));
        window.addEventListener('scroll', this.scroll.bind(this));
    }

    initToggle() {
        const item = this.root;
        const link = this.root.querySelector('.sidebar-menu__toggle');
        const pane = this.root.querySelector('.sidebar-menu__pane');
        if (!link) { return; }

        link.addEventListener('click', (event) => {
            event.preventDefault();

            if (item.classList.contains('opened')) {
                item.classList.remove('opened');
                pane.style.maxHeight = null;
            } else {
                item.classList.add('opened');
                pane.style.maxHeight = pane.scrollHeight + 'px';
            }
        });
    }

    resize() {
        const item = this.root;
        const pane = this.root.querySelector('.sidebar-menu__pane');

        if (item.classList.contains('opened')) {
            pane.style.maxHeight = pane.scrollHeight + 'px';
        }

        this.scroll();
    }

    scroll() {
        if (window.innerWidth < 1644) { return; }

        const rootRect = this.root.getBoundingClientRect();
        const sidebarRect = this.sidebar.getBoundingClientRect();
        const contentRect = this.content.getBoundingClientRect();

        if (contentRect.top - 140 < 0) {
            this.root.classList.add('fixed');
        } else {
            this.root.classList.remove('fixed');
        }

        if (sidebarRect.bottom - (140 + this.root.clientHeight) < 0) {
            this.root.classList.add('to-bottom');
        } else {
            this.root.classList.remove('to-bottom');
        }

        this.sidebarLinks.forEach((link) => {
            const item = this.contentItems[link.hash];
            if (item) {
                const rect = item.getBoundingClientRect();

                if (rect.top < (0.25 * window.innerHeight) &&
                    rect.bottom > (0.25 * window.innerHeight)) {
                    link.classList.add('active');
                } else {
                    link.classList.remove('active');
                }
            }
        });
    }
}

window.app.run(() => {
    document.querySelectorAll('.sidebar-menu').forEach((node) => {
        new SidebarMenu(node);
    });
});
